const ALLOWED_MIME = new Set([
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/jpg',
  'application/pdf',
]);

export const IMPORT_IMAGE_ACCEPT =
  'image/jpeg,image/png,image/webp,application/pdf,.jpg,.jpeg,.png,.webp,.pdf';

export const MAX_IMPORT_IMAGE_BYTES = 10 * 1024 * 1024;

export type ImportMime = 'image/jpeg' | 'image/png' | 'image/webp' | 'application/pdf';

export function normalizeImportMime(mime: string): ImportMime | null {
  const lower = mime.toLowerCase();
  if (lower === 'image/jpg' || lower === 'image/jpeg') return 'image/jpeg';
  if (lower === 'image/png') return 'image/png';
  if (lower === 'image/webp') return 'image/webp';
  if (lower === 'application/pdf') return 'application/pdf';
  return null;
}

export function isAllowedImportMime(mime: string): boolean {
  return ALLOWED_MIME.has(mime.toLowerCase());
}

export function isPdfMime(mime: string): boolean {
  return mime.toLowerCase() === 'application/pdf';
}

export function createLocalImageId(): string {
  return `img_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`;
}

export async function blobToDataUrl(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      if (typeof reader.result === 'string') {
        resolve(reader.result);
        return;
      }
      reject(new Error('Failed to read file'));
    };
    reader.onerror = () => reject(reader.error ?? new Error('Failed to read file'));
    reader.readAsDataURL(blob);
  });
}

export async function uriToDataUrl(uri: string): Promise<string> {
  const response = await fetch(uri);
  const blob = await response.blob();
  return blobToDataUrl(blob);
}

export function ensureDataUrlMime(dataUrl: string, mime: string): string {
  const normalized = normalizeImportMime(mime) ?? 'image/jpeg';
  const base64 = dataUrl.includes('base64,')
    ? dataUrl.slice(dataUrl.indexOf('base64,') + 'base64,'.length)
    : dataUrl.replace(/^data:[^,]*,/, '');
  return `data:${normalized};base64,${base64.replace(/\s/g, '')}`;
}
